"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

require("./styles/_rejection-reasons.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var DEFAULT_REASONS = [].concat(_toConsumableArray(_commonReact.REJECTION_REASONS.REJECT_VERSION), _toConsumableArray(_commonReact.REJECTION_REASONS.SUBMIT_CHANGES));

function RejectionReasonsModal(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose,
      _ref$rejectionReasons = _ref.rejectionReasons,
      rejectionReasons = _ref$rejectionReasons === void 0 ? [] : _ref$rejectionReasons;

  var _rejectionReasons$red = rejectionReasons.reduce(function (_ref2, reasonItem) {
    var reasons = _ref2.reasons,
        comment = _ref2.comment;

    if (!DEFAULT_REASONS.includes(reasonItem)) {
      return {
        reasons: reasons,
        comment: reasonItem
      };
    }

    return {
      reasons: [].concat(_toConsumableArray(reasons), [reasonItem]),
      comment: comment
    };
  }, {
    reasons: [],
    comment: ''
  }),
      defaultReasons = _rejectionReasons$red.reasons,
      userComment = _rejectionReasons$red.comment;

  var isEmpty = !defaultReasons.length && !userComment;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('rejection-reasons', {
      'rejection-reasons--empty': isEmpty
    })
  }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
    visible: visible,
    onClose: onClose,
    onSave: onClose,
    title: "Notes from Internal",
    saveText: "Continue"
  }, defaultReasons.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "rejection-reasons__header"
  }, "Video Rejected"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "rejection-reasons__list"
  }, defaultReasons.map(function (reason, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: reason,
      className: "rejection-reasons__item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "rejection-reasons__item__number"
    }, index + 1), reason);
  }))) : null, userComment ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, defaultReasons.length ? /*#__PURE__*/_react.default.createElement("hr", {
    className: "rejection-reasons__divider"
  }) : null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "rejection-reasons__header"
  }, "Additional Comment"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "rejection-reasons__additional"
  }, userComment)) : null, isEmpty ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "No internal notes exist.") : null));
}

var _default = (0, _react.memo)(RejectionReasonsModal);

exports.default = _default;